import dayjs from 'dayjs';

import { useIsAuth } from '@hook/useIsAuth';
import { ProductDetailsSpecialSmartPriceBanner } from '@components/ProductDetailsSpecialSmartPriceBanner';

import { useProductDetailsFreeDeliveryTimerQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
}

export const ProductDetailsFreeDeliveryTimerContainer: React.FC<Props> = ({
  className,
}) => {
  const isAuth = useIsAuth();

  const { data } = useProductDetailsFreeDeliveryTimerQuery({
    context: {
      batch: true,
    },
    skip: !isAuth,
  });

  const smartInfo = data?.smartInfo;
  const smartInfoEndDate = dayjs(smartInfo?.availableUntilTheTime);

  if (
    smartInfo?.productText
    && smartInfo?.availableUntilTheTime
    && dayjs().isBefore(smartInfoEndDate)
  ) {
    return (
      <ProductDetailsSpecialSmartPriceBanner
        className={className}
        title={smartInfo.productText}
        availableUntilTheTime={smartInfo.availableUntilTheTime}
      />
    );
  }

  return null;
};
